export default "__VITE_ASSET__344e1ab5__"